import styled from 'styled-components';

import { DefaultButtonStyled } from '@/components/atom/buttons/DefaultButton';
import { zIndex } from '@/constants/zIndex';

export const AppHeaderContainer = styled.header`
  z-index: ${zIndex.AppHeader};
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  ${({ theme }) => `
      background-color: ${theme.color.white};
    `};
`;

export const AppHeaderWrapper = styled.div<{ color?: string; left?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  max-width: ${({ theme }) => theme.size.tablet};
  width: 100%;
  height: ${({ theme }) => theme.size.appHeader.height};
  padding: 0 50px;
  ${({ left }) => !left && 'justify-content: center;'};
  ${({ left }) => left && 'padding-left: 18px'};
  background-color: ${({ theme, color }) => (color ? color : theme.color.white)};
`;

export const Title = styled.h1`
  ${({ theme }) => `
    ${theme.typography.UI18SB};
  `};
  overflow: hidden;
  margin: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const LeftButtonWrapper = styled.div`
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 100%;
  left: 0;
`;

export const LeftButton = styled(DefaultButtonStyled)`
  width: 28px;
  height: 28px;
  border-radius: 4px;
  &:active {
    background: ${({ theme }) => theme.color.gray50};
  }
`;

export const AppHeaderLeftButtons = styled.div`
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  left: 16px;
  button:last-child {
    margin-left: 8px;
  }
`;

export const AppHeaderExtendedWrapper = styled.div`
  max-width: ${({ theme }) => theme.size.tablet};
  width: 100%;
`;

export const AppHeaderRightButtons = styled.div`
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  right: 16px;

  button:last-child {
    margin-left: 8px;
  }
`;
